import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card, Input } from "reactstrap";
import {
  getProjectDetails,
  updateProjectInline,
} from "../../api/casp/project";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import { Modules } from "../../constants/Module";
import axios from "axios";
import { generatePreAuthtenticatedRequestForOCI } from "../../api/casp/storage";
import { storeDocument } from "../../api/casp/document";
import { sleep } from "../../helpers/file_helper";
import Divider from "@mui/material/Divider";
import ProjectInfoTab from "./projectInfoTab";
import Grid from "@mui/material/Grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { hasModulePermission } from "../../helpers/permission";
import {
  AcceptFileType,
  Action,
  ProjectTag,
  Role,
} from "../../constants/Common";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { withTranslation } from "react-i18next";
import UserProfile from "../casp/common/userProfile";
import { toast } from "react-toastify";
import DescriptionIcon from "@mui/icons-material/Description";
import { useSelector } from "react-redux";
import { ProjectStatuses } from "../../constants/Status";

const ProjectInfo = (props) => {
  const { project } = useParams();
  const [projectDetails, setProjectDetails] = useState([]);
  const [projectDescription, setProjectDescription] = useState();
  const [projectTag, setProjectTag] = useState();
  const [projectInfo, setProjectInfo] = useState();
  const [projectStartDate, setProjectStartDate] = useState();
  const [projectEndDate, setProjectEndDate] = useState();
  const [isOpenScopeEdit, setIsOpenScopeEdit] = useState(false);
  const [isOpenDescriptionEdit, setIsOpenDescriptionEdit] = useState(false);
  const [isOpenStartDateEdit, setIsOpenStartDateEdit] = useState(false);
  const [isOpenEndDateEdit, setIsOpenEndDateEdit] = useState(false);
  const [uniqueProjectId, setUniqueProjectId] = useState();
  const [projectScope, setProjectScope] = useState();
  const [update, setUpdate] = useState(+new Date());
  const inputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const hasCreatePermissionForProjectCoreDocument = hasModulePermission(
    Modules.PROJECT_CORE_DOCUMENT,
    Action.CREATE
  );
  const [readMore, setReadMore] = useState(false);
  const [isScopeExpanded, setIsScopeExpanded] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  // const isSpecificCompany = ["NTDP", "JST"].includes(
  //   loggedInUser?.company?.name
  // );
  const { projectUser } = useSelector((state) => ({
    projectUser: state.projectUser.projectUser,
  }));
  useEffect(() => {
    if (project) {
      getProjDetailsMethod(project);
    }
  }, []);

  const getProjDetailsMethod = async (id) => {
    try {
      const res = await getProjectDetails(id);
      const projectInfo = [];
      setProjectInfo(res.data.data);
      setProjectTag(res.data.data.tag);
      setProjectStartDate(res.data.data.startDate);
      setProjectEndDate(res.data.data.endDate);
      Object.entries(res.data.data).forEach(([_key, _value]) => {
        let details;
        switch (_key) {
          case "uniqueProjectId":
            details = {
              proDetailIcon: (
                <svg
                  width="12"
                  height="14"
                  viewBox="0 0 6 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.99992 7.99999L0.599919 6.11428C0.516585 6.05025 0.451308 5.96877 0.404085 5.86983C0.356863 5.77089 0.333252 5.66613 0.333252 5.55555V1.36507C0.333252 1.17301 0.39853 1.00859 0.529085 0.871815C0.659641 0.735043 0.816585 0.666656 0.999919 0.666656H4.99992C5.18325 0.666656 5.3402 0.735043 5.47075 0.871815C5.60131 1.00859 5.66659 1.17301 5.66659 1.36507V5.55555C5.66659 5.66613 5.64297 5.77089 5.59575 5.86983C5.54853 5.96877 5.48325 6.05025 5.39992 6.11428L2.99992 7.99999ZM2.64992 5.20634L4.53325 3.23332L4.06659 2.72697L2.64992 4.2111L1.94992 3.47777L1.46659 3.96666L2.64992 5.20634Z"
                    fill="#1150D7"
                  />
                </svg>
              ),
              bgColor: "#C1D4FE",
              projDetailTitle: props.t("Startup ID"),
              projDetailDesc: _value || "00X00X",
            };
            break;

          case "portfolio":
            details = {
              proDetailIcon: (
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.977273 6C0.777273 6 0.606061 5.92656 0.463636 5.77969C0.321212 5.63281 0.25 5.45625 0.25 5.25V1.125H0.977273V5.25H7.15909V6H0.977273ZM2.43182 4.5C2.23182 4.5 2.06061 4.42656 1.91818 4.27969C1.77576 4.13281 1.70455 3.95625 1.70455 3.75V0.75C1.70455 0.54375 1.77576 0.367188 1.91818 0.220313C2.06061 0.0734375 2.23182 0 2.43182 0H7.52273C7.72273 0 7.89394 0.0734375 8.03636 0.220313C8.17879 0.367188 8.25 0.54375 8.25 0.75V3.75C8.25 3.95625 8.17879 4.13281 8.03636 4.27969C7.89394 4.42656 7.72273 4.5 7.52273 4.5H2.43182ZM3.15909 3.75C3.15909 3.54375 3.08788 3.36719 2.94545 3.22031C2.80303 3.07344 2.63182 3 2.43182 3V3.75H3.15909ZM6.79545 3.75H7.52273V3C7.32273 3 7.15152 3.07344 7.00909 3.22031C6.86667 3.36719 6.79545 3.54375 6.79545 3.75ZM4.97727 3.375C5.2803 3.375 5.53788 3.26562 5.75 3.04688C5.96212 2.82812 6.06818 2.5625 6.06818 2.25C6.06818 1.9375 5.96212 1.67188 5.75 1.45312C5.53788 1.23438 5.2803 1.125 4.97727 1.125C4.67424 1.125 4.41667 1.23438 4.20455 1.45312C3.99242 1.67188 3.88636 1.9375 3.88636 2.25C3.88636 2.5625 3.99242 2.82812 4.20455 3.04688C4.41667 3.26562 4.67424 3.375 4.97727 3.375ZM2.43182 1.5C2.63182 1.5 2.80303 1.42656 2.94545 1.27969C3.08788 1.13281 3.15909 0.95625 3.15909 0.75H2.43182V1.5ZM7.52273 1.5V0.75H6.79545C6.79545 0.95625 6.86667 1.13281 7.00909 1.27969C7.15152 1.42656 7.32273 1.5 7.52273 1.5Z"
                    fill="#F98906"
                  />
                </svg>
              ),
              bgColor: "#FFEDAE",
              projDetailTitle: props.t("Cohort"),
              projDetailDesc: _value?.name,
            };
            break;
          case "projectAdmin":
            details = {
              proDetailIcon: (
                <svg
                  width="14"
                  height="13"
                  viewBox="0 0 8 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.64232 7L5.52141 6.38235C5.44081 6.34804 5.36524 6.31201 5.29471 6.27426C5.22418 6.23652 5.15197 6.1902 5.07809 6.13529L4.4937 6.32059L4.09068 5.62059L4.55416 5.20882C4.54072 5.11275 4.53401 5.02353 4.53401 4.94118C4.53401 4.85882 4.54072 4.76961 4.55416 4.67353L4.09068 4.26177L4.4937 3.56176L5.07809 3.74706C5.15197 3.69216 5.22418 3.64583 5.29471 3.60809C5.36524 3.57034 5.44081 3.53431 5.52141 3.5L5.64232 2.88235H6.44836L6.56927 3.5C6.64987 3.53431 6.72544 3.57206 6.79597 3.61324C6.8665 3.65441 6.93871 3.70588 7.01259 3.76765L7.59698 3.56176L8 4.28235L7.53652 4.69412C7.54996 4.77647 7.55667 4.86226 7.55667 4.95147C7.55667 5.04069 7.54996 5.12647 7.53652 5.20882L8 5.62059L7.59698 6.32059L7.01259 6.13529C6.93871 6.1902 6.8665 6.23652 6.79597 6.27426C6.72544 6.31201 6.64987 6.34804 6.56927 6.38235L6.44836 7H5.64232ZM0 6.58824V5.43529C0 5.20882 0.0570949 4.99608 0.171285 4.79706C0.285474 4.59804 0.443325 4.44706 0.644836 4.34412C0.987406 4.16569 1.37364 4.01471 1.80353 3.89118C2.23342 3.76765 2.70697 3.70588 3.22418 3.70588H3.36524C3.40554 3.70588 3.44584 3.71275 3.48615 3.72647C3.29135 4.22059 3.21075 4.71127 3.24433 5.19853C3.27792 5.68578 3.43913 6.14902 3.72796 6.58824H0ZM6.04534 5.76471C6.267 5.76471 6.45676 5.68407 6.61461 5.52279C6.77246 5.36152 6.85139 5.16765 6.85139 4.94118C6.85139 4.71471 6.77246 4.52083 6.61461 4.35956C6.45676 4.19828 6.267 4.11765 6.04534 4.11765C5.82368 4.11765 5.63392 4.19828 5.47607 4.35956C5.31822 4.52083 5.2393 4.71471 5.2393 4.94118C5.2393 5.16765 5.31822 5.36152 5.47607 5.52279C5.63392 5.68407 5.82368 5.76471 6.04534 5.76471ZM3.22418 3.29412C2.78086 3.29412 2.40134 3.13284 2.08564 2.81029C1.76994 2.48775 1.61209 2.1 1.61209 1.64706C1.61209 1.19412 1.76994 0.806373 2.08564 0.483824C2.40134 0.161275 2.78086 0 3.22418 0C3.66751 0 4.04702 0.161275 4.36272 0.483824C4.67842 0.806373 4.83627 1.19412 4.83627 1.64706C4.83627 2.1 4.67842 2.48775 4.36272 2.81029C4.04702 3.13284 3.66751 3.29412 3.22418 3.29412Z"
                    fill="#E841AF"
                  />
                </svg>
              ),
              bgColor: "#FFD8F2",
              projDetailTitle: props.t("Founder"),
              projDetailDesc: _value?.name,
              name: _value?.name,
              profilePicture: _value?.profilePicture,
            };
            break;
            /* Remove Startup Owner */
          // case "projectOwner":
          //   // setHasAvatar(true);
          //   details = {
          //     proDetailIcon: (
          //       <svg
          //         width="12"
          //         height="12"
          //         viewBox="0 0 7 6"
          //         fill="none"
          //         xmlns="http://www.w3.org/2000/svg"
          //       >
          //         <path
          //           d="M3.5 3C3.0875 3 2.73438 2.85313 2.44063 2.55938C2.14688 2.26562 2 1.9125 2 1.5C2 1.0875 2.14688 0.734375 2.44063 0.440625C2.73438 0.146875 3.0875 0 3.5 0C3.9125 0 4.26562 0.146875 4.55937 0.440625C4.85313 0.734375 5 1.0875 5 1.5C5 1.9125 4.85313 2.26562 4.55937 2.55938C4.26562 2.85313 3.9125 3 3.5 3ZM0.5 6V4.95C0.5 4.7375 0.554688 4.54219 0.664063 4.36406C0.773438 4.18594 0.91875 4.05 1.1 3.95625C1.4875 3.7625 1.88125 3.61719 2.28125 3.52031C2.68125 3.42344 3.0875 3.375 3.5 3.375C3.9125 3.375 4.31875 3.42344 4.71875 3.52031C5.11875 3.61719 5.5125 3.7625 5.9 3.95625C6.08125 4.05 6.22656 4.18594 6.33594 4.36406C6.44531 4.54219 6.5 4.7375 6.5 4.95V6H0.5Z"
          //           fill="#803DD7"
          //         />
          //       </svg>
          //     ),
          //     bgColor: "#E5D1FF",
          //     projDetailTitle: props.t("Project Owner"),
          //     projDetailDesc: _value?.name,
          //     name: _value?.name,
          //     profilePicture: _value?.profilePicture,
          //   };
          //   break;
          /* Remove Startup Sponsor */
          // case "projectSponsor":
          //   details = {
          //     proDetailIcon: (
          //       <svg
          //         width="14"
          //         height="12"
          //         viewBox="0 0 9 6"
          //         fill="none"
          //         xmlns="http://www.w3.org/2000/svg"
          //       >
          //         <path
          //           d="M0.25 6V4.95C0.25 4.7375 0.30303 4.54219 0.409091 4.36406C0.515152 4.18594 0.656061 4.05 0.831818 3.95625C1.20758 3.7625 1.58939 3.61719 1.97727 3.52031C2.36515 3.42344 2.75909 3.375 3.15909 3.375C3.55909 3.375 3.95303 3.42344 4.34091 3.52031C4.72879 3.61719 5.11061 3.7625 5.48636 3.95625C5.66212 4.05 5.80303 4.18594 5.90909 4.36406C6.01515 4.54219 6.06818 4.7375 6.06818 4.95V6H0.25ZM6.79545 6V4.875C6.79545 4.6 6.72121 4.33594 6.57273 4.08281C6.42424 3.82969 6.21364 3.6125 5.94091 3.43125C6.25 3.46875 6.54091 3.53281 6.81364 3.62344C7.08636 3.71406 7.34091 3.825 7.57727 3.95625C7.79545 4.08125 7.96212 4.22031 8.07727 4.37344C8.19242 4.52656 8.25 4.69375 8.25 4.875V6H6.79545ZM3.15909 3C2.75909 3 2.41667 2.85313 2.13182 2.55938C1.84697 2.26562 1.70455 1.9125 1.70455 1.5C1.70455 1.0875 1.84697 0.734375 2.13182 0.440625C2.41667 0.146875 2.75909 0 3.15909 0C3.55909 0 3.90152 0.146875 4.18636 0.440625C4.47121 0.734375 4.61364 1.0875 4.61364 1.5C4.61364 1.9125 4.47121 2.26562 4.18636 2.55938C3.90152 2.85313 3.55909 3 3.15909 3ZM6.79545 1.5C6.79545 1.9125 6.65303 2.26562 6.36818 2.55938C6.08333 2.85313 5.74091 3 5.34091 3C5.27424 3 5.18939 2.99219 5.08636 2.97656C4.98333 2.96094 4.89849 2.94375 4.83182 2.925C4.99545 2.725 5.12121 2.50312 5.20909 2.25938C5.29697 2.01562 5.34091 1.7625 5.34091 1.5C5.34091 1.2375 5.29697 0.984375 5.20909 0.740625C5.12121 0.496875 4.99545 0.275 4.83182 0.075C4.91667 0.04375 5.00152 0.0234375 5.08636 0.0140625C5.17121 0.0046875 5.25606 0 5.34091 0C5.74091 0 6.08333 0.146875 6.36818 0.440625C6.65303 0.734375 6.79545 1.0875 6.79545 1.5Z"
          //           fill="#4E9903"
          //         />
          //       </svg>
          //     ),
          //     bgColor: "#D6FFAD",
          //     projDetailTitle: props.t("Project Sponsor"),
          //     projDetailDesc: _value?.name,
          //     name: _value?.name,
          //     profilePicture: _value?.profilePicture,
          //   };
          //   break;

          case "startDate":
            details = {
              proDetailIcon: (
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 9 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.61111 6.4C5.3 6.4 5.03704 6.30333 4.82222 6.11C4.60741 5.91667 4.5 5.68 4.5 5.4C4.5 5.12 4.60741 4.88333 4.82222 4.69C5.03704 4.49667 5.3 4.4 5.61111 4.4C5.92222 4.4 6.18519 4.49667 6.4 4.69C6.61482 4.88333 6.72222 5.12 6.72222 5.4C6.72222 5.68 6.61482 5.91667 6.4 6.11C6.18519 6.30333 5.92222 6.4 5.61111 6.4ZM1.38889 8C1.14444 8 0.935185 7.92167 0.761111 7.765C0.587037 7.60833 0.5 7.42 0.5 7.2V1.6C0.5 1.38 0.587037 1.19167 0.761111 1.035C0.935185 0.878333 1.14444 0.8 1.38889 0.8H1.83333V0H2.72222V0.8H6.27778V0H7.16667V0.8H7.61111C7.85556 0.8 8.06482 0.878333 8.23889 1.035C8.41296 1.19167 8.5 1.38 8.5 1.6V7.2C8.5 7.42 8.41296 7.60833 8.23889 7.765C8.06482 7.92167 7.85556 8 7.61111 8H1.38889ZM1.38889 7.2H7.61111V3.2H1.38889V7.2Z"
                    fill="#1365C6"
                  />
                </svg>
              ),
              bgColor: "#D0E6FF",
              projDetailTitle: props.t("Start Date"),
              projDetailDesc:
                _value !== null ? dayjs(_value).format("DD MMM YYYY") : "N/A",
            };
            break;
          case "endDate":
            details = {
              proDetailIcon: (
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 9 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.86111 6.4C5.55 6.4 5.28704 6.30333 5.07222 6.11C4.85741 5.91667 4.75 5.68 4.75 5.4C4.75 5.12 4.85741 4.88333 5.07222 4.69C5.28704 4.49667 5.55 4.4 5.86111 4.4C6.17222 4.4 6.43519 4.49667 6.65 4.69C6.86482 4.88333 6.97222 5.12 6.97222 5.4C6.97222 5.68 6.86482 5.91667 6.65 6.11C6.43519 6.30333 6.17222 6.4 5.86111 6.4ZM1.63889 8C1.39444 8 1.18519 7.92167 1.01111 7.765C0.837037 7.60833 0.75 7.42 0.75 7.2V1.6C0.75 1.38 0.837037 1.19167 1.01111 1.035C1.18519 0.878333 1.39444 0.8 1.63889 0.8H2.08333V0H2.97222V0.8H6.52778V0H7.41667V0.8H7.86111C8.10556 0.8 8.31482 0.878333 8.48889 1.035C8.66296 1.19167 8.75 1.38 8.75 1.6V7.2C8.75 7.42 8.66296 7.60833 8.48889 7.765C8.31482 7.92167 8.10556 8 7.86111 8H1.63889ZM1.63889 7.2H7.86111V3.2H1.63889V7.2Z"
                    fill="#0D9C01"
                  />
                </svg>
              ),
              bgColor: "#D4FFD0",
              projDetailTitle: props.t("End Date"),
              projDetailDesc:
                _value !== null ? dayjs(_value).format("DD MMM YYYY") : "N/A",
            };
            break;
          case "projectCost":
            details = {
              proDetailIcon: (
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.977273 6C0.777273 6 0.606061 5.92656 0.463636 5.77969C0.321212 5.63281 0.25 5.45625 0.25 5.25V1.125H0.977273V5.25H7.15909V6H0.977273ZM2.43182 4.5C2.23182 4.5 2.06061 4.42656 1.91818 4.27969C1.77576 4.13281 1.70455 3.95625 1.70455 3.75V0.75C1.70455 0.54375 1.77576 0.367188 1.91818 0.220313C2.06061 0.0734375 2.23182 0 2.43182 0H7.52273C7.72273 0 7.89394 0.0734375 8.03636 0.220313C8.17879 0.367188 8.25 0.54375 8.25 0.75V3.75C8.25 3.95625 8.17879 4.13281 8.03636 4.27969C7.89394 4.42656 7.72273 4.5 7.52273 4.5H2.43182ZM3.15909 3.75C3.15909 3.54375 3.08788 3.36719 2.94545 3.22031C2.80303 3.07344 2.63182 3 2.43182 3V3.75H3.15909ZM6.79545 3.75H7.52273V3C7.32273 3 7.15152 3.07344 7.00909 3.22031C6.86667 3.36719 6.79545 3.54375 6.79545 3.75ZM4.97727 3.375C5.2803 3.375 5.53788 3.26562 5.75 3.04688C5.96212 2.82812 6.06818 2.5625 6.06818 2.25C6.06818 1.9375 5.96212 1.67188 5.75 1.45312C5.53788 1.23438 5.2803 1.125 4.97727 1.125C4.67424 1.125 4.41667 1.23438 4.20455 1.45312C3.99242 1.67188 3.88636 1.9375 3.88636 2.25C3.88636 2.5625 3.99242 2.82812 4.20455 3.04688C4.41667 3.26562 4.67424 3.375 4.97727 3.375ZM2.43182 1.5C2.63182 1.5 2.80303 1.42656 2.94545 1.27969C3.08788 1.13281 3.15909 0.95625 3.15909 0.75H2.43182V1.5ZM7.52273 1.5V0.75H6.79545C6.79545 0.95625 6.86667 1.13281 7.00909 1.27969C7.15152 1.42656 7.32273 1.5 7.52273 1.5Z"
                    fill="#F98906"
                  />
                </svg>
              ),
              bgColor: "#FFEDAE",
              projDetailTitle: props.t("Total Budget"),
              projDetailDesc: `SAR ${parseFloat(_value).toFixed(2)}`,
            };
            break;
          // case "jobs":
          //   details = {
          //     proDetailIcon: (
          //       <svg
          //         width="12"
          //         height="14"
          //         viewBox="0 0 6 8"
          //         fill="none"
          //         xmlns="http://www.w3.org/2000/svg"
          //       >
          //         <path
          //           d="M2.99992 7.99999L0.599919 6.11428C0.516585 6.05025 0.451308 5.96877 0.404085 5.86983C0.356863 5.77089 0.333252 5.66613 0.333252 5.55555V1.36507C0.333252 1.17301 0.39853 1.00859 0.529085 0.871815C0.659641 0.735043 0.816585 0.666656 0.999919 0.666656H4.99992C5.18325 0.666656 5.3402 0.735043 5.47075 0.871815C5.60131 1.00859 5.66659 1.17301 5.66659 1.36507V5.55555C5.66659 5.66613 5.64297 5.77089 5.59575 5.86983C5.54853 5.96877 5.48325 6.05025 5.39992 6.11428L2.99992 7.99999ZM2.64992 5.20634L4.53325 3.23332L4.06659 2.72697L2.64992 4.2111L1.94992 3.47777L1.46659 3.96666L2.64992 5.20634Z"
          //           fill="#1150D7"
          //         />
          //       </svg>
          //     ),
          //     bgColor: "#FFE8CC",
          //     projDetailTitle: props.t("Number of jobs"),
          //     projDetailDesc: _value?.toString(),
          //   };
          //   break;
          default:
            break;
        }
        if (details) {
          projectInfo.push(details);
        }
      });
      // taken as initially
      // const projectOwnerIndex = projectInfo.findIndex(
      //   (pi) => pi.projDetailTitle === "Project Owner"
      // );
      // Remove Manager
      // if (projectOwnerIndex !== -1) {
      //   projectInfo.splice(projectOwnerIndex + 1, 0, {
      //     proDetailIcon: (
      //       <svg
      //         width="12"
      //         height="12"
      //         viewBox="0 0 6 6"
      //         fill="none"
      //         xmlns="http://www.w3.org/2000/svg"
      //       >
      //         <path
      //           d="M3.33333 2V0H6V2H3.33333ZM0 3.33333V0H2.66667V3.33333H0ZM3.33333 6V2.66667H6V6H3.33333ZM0 6V4H2.66667V6H0Z"
      //           fill="#1195A9"
      //         />
      //       </svg>
      //     ),
      //     bgColor: "#C9F8FF",
      //     projDetailTitle: props.t("Manager"),
      //     projDetailDesc:
      //       res.data.data.portfolioProjects[0]?.portfolio?.assignee?.name,
      //     name: res.data.data.portfolioProjects[0]?.portfolio?.assignee?.name,
      //     profilePicture:
      //       res.data.data.portfolioProjects[0]?.portfolio?.assignee
      //         ?.profilePicture,
      //   });
      // }
      projectInfo.push(
        // {
        //     projDetailTitle: 'Client',
        //     projDetailDesc: 'Y Company'
        // },
        // {
        //     projDetailTitle: 'Related Initiative',
        //     projDetailDesc: 'Increase customer satisfaction'
        // },
        {
          proDetailIcon: (
            <svg
              width="14"
              height="14"
              viewBox="0 0 8 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.66667 0.857143V0H5.33333V0.857143H2.66667ZM3.55556 5.57143H4.44444V3H3.55556V5.57143ZM4 9C3.45185 9 2.93519 8.89821 2.45 8.69464C1.96481 8.49107 1.54074 8.21429 1.17778 7.86429C0.814815 7.51429 0.527778 7.10536 0.316667 6.6375C0.105556 6.16964 0 5.67143 0 5.14286C0 4.61429 0.105556 4.11607 0.316667 3.64821C0.527778 3.18036 0.814815 2.77143 1.17778 2.42143C1.54074 2.07143 1.96481 1.79464 2.45 1.59107C2.93519 1.3875 3.45185 1.28571 4 1.28571C4.45926 1.28571 4.9 1.35714 5.32222 1.5C5.74444 1.64286 6.14074 1.85 6.51111 2.12143L7.13333 1.52143L7.75556 2.12143L7.13333 2.72143C7.41482 3.07857 7.62963 3.46071 7.77778 3.86786C7.92593 4.275 8 4.7 8 5.14286C8 5.67143 7.89444 6.16964 7.68333 6.6375C7.47222 7.10536 7.18519 7.51429 6.82222 7.86429C6.45926 8.21429 6.03519 8.49107 5.55 8.69464C5.06482 8.89821 4.54815 9 4 9Z"
                fill="#0E79B5"
              />
            </svg>
          ),
          bgColor: "#D3EFFF",
          projDetailTitle: props.t("Duration"),
          projDetailDesc: differenceInMonths(
            res.data.data.endDate !== null
              ? new Date(res.data.data.endDate)
              : undefined,
            res.data.data.startDate !== null
              ? new Date(res.data.data.startDate)
              : undefined
          ),
        }
        // {
        //     proDetailIcon: <svg width="14" height="13" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M5.81174 6L4.03846 4.17753L4.71862 3.4785L6.4919 5.30097L5.81174 6ZM1.34211 6L0.661943 5.30097L2.89676 3.00416L2.34615 2.43828L2.11943 2.67129L1.70648 2.24688V2.92926L1.47976 3.16227L0.5 2.15534L0.726721 1.92233H1.39069L0.98583 1.50624L2.13563 0.324549C2.24359 0.213592 2.35965 0.133148 2.48381 0.0832178C2.60796 0.0332871 2.73482 0.00832181 2.86437 0.00832181C2.99393 0.00832181 3.12078 0.0332871 3.24494 0.0832178C3.3691 0.133148 3.48516 0.213592 3.59312 0.324549L2.84818 1.09015L3.25304 1.50624L3.02632 1.73925L3.57692 2.30513L4.30567 1.55617C4.28408 1.49515 4.26659 1.43135 4.2532 1.36477C4.2396 1.2982 4.23279 1.23162 4.23279 1.16505C4.23279 0.837725 4.34216 0.561664 4.56089 0.336866C4.77941 0.112289 5.04791 0 5.3664 0C5.44737 0 5.52435 0.00832179 5.59733 0.0249653C5.67009 0.0416089 5.74426 0.0665743 5.81984 0.0998614L5.01822 0.923717L5.60121 1.52288L6.40283 0.699029C6.44062 0.776699 6.46632 0.852927 6.47992 0.927712C6.49331 1.00272 6.5 1.08183 6.5 1.16505C6.5 1.49237 6.39074 1.76832 6.17223 1.9929C5.9535 2.2177 5.68489 2.3301 5.3664 2.3301C5.30162 2.3301 5.23684 2.32455 5.17206 2.31345C5.10729 2.30236 5.04521 2.28294 4.98583 2.2552L1.34211 6Z" fill="#2B2F3E"/>
        //     </svg>,
        //     bgColor: '#D3D7E8',
        //     projDetailTitle: props.t('Scope of Work'),
        //     projDetailDesc: res.data.data.scope ? res.data.data.scope : 'N/A'
        // }
      );
      setProjectDetails(projectInfo);
      setProjectScope(res.data.data.scope);
      setProjectDescription(res.data.data.description);
      setUniqueProjectId(res.data.data.uniqueProjectId);
    } catch (error) {
      console.log(error);
    }
  };
  const toggleTextExpansion = (key, index) => {
    setReadMore(true);
  };

  const differenceInMonths = (date1, date2) => {
    if (date1 && date2) {
      const endDate = dayjs(date1);
      const startDate = dayjs(date2);
      const diffMonth = endDate.diff(startDate, "month");
      if (diffMonth < 12) {
        return diffMonth === 1 || diffMonth === 0
          ? `${diffMonth} month`
          : `${diffMonth} months`;
      } else {
        const yearDiff = Math.floor(diffMonth / 12);

        const remainder = diffMonth % 12;
        let duration;
        if (yearDiff === 1) {
          duration = `${yearDiff} year`;
        }
        if (yearDiff > 1) {
          duration = `${yearDiff} years`;
        }
        if (remainder !== 0) {
          if (remainder === 1) {
            duration = duration + ` ${remainder} month`;
          } else {
            duration = duration + ` ${remainder} months`;
          }
        }
        return duration;
      }
    } else {
      return "N/A";
    }
  };

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  // function stringAvatar(name) {
  //   if (!name) {
  //     return {};
  //   }
  //   return {
  //     sx: {
  //       bgcolor: stringToColor(name),
  //     },
  //     children: `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}`,
  //   };
  // }

  const handleFileUpload = async (event) => {
    try {
      for (let file of event.target.files) {
        const fileExtension = file
          ? `.${file.name.split(".").pop().toLowerCase()}`
          : "";
        if (file && !AcceptFileType.includes(fileExtension)) {
          file = null;
          return toast.error("Invalid file type");
        }
        if (file.size > 1024 * 1024 * 10) {
          return toast.error(
            "Payload content length greater than maximum allowed: 10 MB"
          );
        }
      }
      setSelectedFiles(
        [...event.target.files].map((file) => ({
          progress: 0,
          file,
        }))
      );
      for (let index = 0; index < [...event.target.files].length; index++) {
        const file = event.target.files[index];
        const data = {
          module: Modules.PROJECT,
          moduleId: project,
          action: "write",
          filename: file.name,
        };
        const preAuthResponse = await generatePreAuthtenticatedRequestForOCI(
          data
        );
        await axios.put(
          `${preAuthResponse.data.data.preauthenticatedRequest.fullPath}${preAuthResponse.data.data.path}`,
          file,
          {
            headers: {
              "Content-Length": file.size,
            },
            onUploadProgress: (progressEvent) => {
              setSelectedFiles((prev) => {
                prev[index] = {
                  ...prev[index],
                  progress: parseInt(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ),
                };
                return [...prev];
              });
            },
          }
        );

        const documentPayload = {
          projectId: project,
          name: file.name,
          documentTypeId: 1,
          storageLink: `${preAuthResponse.data.data.path}`,
          module: Modules.PROJECT,
          moduleId: project,
        };
        await storeDocument(documentPayload);
        // sleep execution
        await sleep(500);
        setUpdate(+new Date());
        await toast.success("File uploaded successfully.");
      }
    } catch (e) {
      console.log(e);
      await toast.error(e?.message);
    } finally {
      setSelectedFiles([]);
    }
  };

  const toggleScopeExpansion = () => {
    setIsScopeExpanded(!isScopeExpanded);
  };
  const toggleDescriptionExpansion = () => {
    setIsDescriptionExpanded(!isDescriptionExpanded);
  };
  const maxLength = 300;
  const scopeLength = projectScope ? projectScope.length : 0;
  const descriptionLength = projectDescription ? projectDescription.length : 0;
  const shouldTruncateScope = scopeLength > maxLength && !isScopeExpanded;
  const shouldTruncateDescription =
    descriptionLength > maxLength && !isDescriptionExpanded;
  const handleEdit = async () => {
    try {
      const payload = {
        description: projectDescription ? projectDescription.trim() : "",
        scope: projectScope ? projectScope.trim() : "",
        startDate: projectStartDate,
        endDate: projectEndDate,
      };
      const response = await updateProjectInline(payload, project);
      if (response.statusCode === 200) {
        getProjDetailsMethod(project);
        toast.success(response.data.message);
        setIsOpenScopeEdit(false);
        setIsOpenDescriptionEdit(false);
        setIsOpenStartDateEdit(false);
        setIsOpenEndDateEdit(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const itemsPerRow = 4; // Because you use xs={3}
const placeholdersNeeded = projectDetails.length > 0
  ? (itemsPerRow - (projectDetails.length % itemsPerRow)) % itemsPerRow
  : 0;

  return (
    <div className="projectInfo">
      {/* <div className='projId mt-2 mb-3'>
                Project ID : {uniqueProjectId ? uniqueProjectId : '00X00X'}
            </div> */}
      <Card className="customCard viewProjectApproval mx-4">
        <div className="projDetails">
          <Grid container className="projDetailsListing">
            {projectDetails.map((item, index) => (
              <Grid item xs={3} key={index} className="singleList">
                <div className="projDetailTitle">
                  <span
                    style={{ backgroundColor: item.bgColor }}
                    className="dashboardProjectIcon"
                  >
                    {item.proDetailIcon}
                  </span>{" "}
                  &nbsp;
                  {item.projDetailTitle?.replace("Project", "Startup")}
                  {/* {(item.projDetailTitle === props.t("Start Date") ||
                    item.projDetailTitle === props.t("End Date")) &&
                    projectInfo?.status === ProjectStatuses.DRAFT &&
                    projectUser?.role?.name === Role.PROJECT_MANAGER && (
                      <EditOutlinedIcon
                        style={{
                          fill: "#6B7083",
                          fontSize: "14px",
                          cursor: "pointer",
                          marginLeft: "5px",
                        }} // Added cursor and margin
                        onClick={() => {
                          item.projDetailTitle === props.t("Start Date")
                            ? setIsOpenStartDateEdit(true)
                            : setIsOpenEndDateEdit(true);
                        }}
                      />
                    )}
                  {isOpenStartDateEdit &&
                    item.projDetailTitle === props.t("Start Date") && (
                      <div className="edit-date-section">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              sx={{ mb: 1, width: "100%" }}
                              className="form-control"
                              format="MM/DD/YYYY"
                              name="startDate"
                              value={
                                projectStartDate &&
                                projectStartDate.toString().trim()
                                  ? dayjs(projectStartDate)
                                  : null
                              }
                              onChange={(e) => {
                                setProjectStartDate(
                                  e ? dayjs(e).format("YYYY-MM-DD") : ""
                                );
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <div className="d-flex mt-2">
                          <Button
                            className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn-height-30"
                            variant="contained"
                            size="small"
                            style={{ marginRight: "8px" }}
                            type="submit"
                            onClick={handleEdit}
                          >
                            {props.t("Submit")}
                          </Button>
                          <Button
                            className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn-height-30"
                            variant="outlined"
                            size="small"
                            type="button"
                            onClick={() => setIsOpenStartDateEdit(false)}
                          >
                            {props.t("Cancel")}
                          </Button>
                        </div>
                      </div>
                    )}
                  {isOpenEndDateEdit &&
                    item.projDetailTitle === props.t("End Date") && (
                      <div className="edit-date-section">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              sx={{ mb: 1, width: "100%" }}
                              className="form-control"
                              format="MM/DD/YYYY"
                              name="endDate"
                              value={
                                projectEndDate &&
                                projectEndDate.toString().trim()
                                  ? dayjs(projectEndDate)
                                  : null
                              }
                              onChange={(e) => {
                                setProjectEndDate(
                                  e ? dayjs(e).format("YYYY-MM-DD") : ""
                                );
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <div className="d-flex mt-2">
                          <Button
                            className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn-height-30"
                            variant="contained"
                            size="small"
                            style={{ marginRight: "8px" }}
                            type="submit"
                            onClick={handleEdit}
                          >
                            {props.t("Submit")}
                          </Button>
                          <Button
                            className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn-height-30"
                            variant="outlined"
                            size="small"
                            type="button"
                            onClick={() => setIsOpenEndDateEdit(false)}
                          >
                            {props.t("Cancel")}
                          </Button>
                        </div>
                      </div>
                    )} */}
                </div>
                <div
                  className={`projDetailDesc ${
                    item.projDetailTitle !== props.t("Scope Of Work")
                      ? "d-flex gap-2  align-items-center"
                      : ""
                  } ${
                    item.projDetailTitle === "Project Sponsor"
                      ? "projectSponsorBlock"
                      : ""
                  }`}
                >
                  {(item.projDetailTitle === "Founder" ||
                    item.projDetailTitle === "Project Owner" ||
                    item.projDetailTitle === "Project Sponsor" ||
                    item.projDetailTitle === "Manager") && (
                    <UserProfile user={item} />
                  )}
                  {item.projDetailTitle === props.t("Scope Of Work") &&
                  item.projDetailDesc.length < 45 ? (
                    <>{item.projDetailDesc}</>
                  ) : (
                    <>
                      {item.projDetailTitle === props.t("Start Date") &&
                      isOpenStartDateEdit ? (
                        <></>
                      ) : item.projDetailTitle === props.t("End Date") &&
                        isOpenEndDateEdit ? (
                        <></>
                      ) : (
                        item.projDetailDesc?.slice(0, 45)
                      )}
                    </>
                  // )}
                  // {item.projDetailTitle === props.t("Scope Of Work") &&
                  //   item.projDetailDesc.length > 45 &&
                  //   readMore && <>{item.projDetailDesc}</>}
                  // {item.projDetailTitle === props.t("Scope Of Work") &&
                  //   item.projDetailDesc.length > 45 &&
                  //   !readMore && (
                  //     <span
                  //       className="blue-pointer-text cursor-pointer"
                  //       // onClick={() =>
                  //       //     toggleTextExpansion(item.projDetailDesc, index)
                  //       // }
                  //     >
                  //       {"..." + props.t("read more")}
                  //     </span>
                    )}
                </div>
              </Grid>
            ))}
            {placeholdersNeeded > 0 &&
              Array.from({ length: placeholdersNeeded }).map(
                (_, placeholderIndex) => (
                  <Grid
                    item
                    xs={3}
                    key={`placeholder-${placeholderIndex}`}
                    className="singleList emptyPlaceholder"
                  >
                    &nbsp;
                  </Grid>
                )
              )}
          </Grid>
        </div>
        {/* <div className="proBlock scope py-3">
          <div className="d-flex gap-2">
            <div className="projDetailTitle">
              <span
                style={{ backgroundColor: "#D3D7E8" }}
                className="dashboardProjectIcon"
              >
                <svg
                  width="14"
                  height="13"
                  viewBox="0 0 7 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.81174 6L4.03846 4.17753L4.71862 3.4785L6.4919 5.30097L5.81174 6ZM1.34211 6L0.661943 5.30097L2.89676 3.00416L2.34615 2.43828L2.11943 2.67129L1.70648 2.24688V2.92926L1.47976 3.16227L0.5 2.15534L0.726721 1.92233H1.39069L0.98583 1.50624L2.13563 0.324549C2.24359 0.213592 2.35965 0.133148 2.48381 0.0832178C2.60796 0.0332871 2.73482 0.00832181 2.86437 0.00832181C2.99393 0.00832181 3.12078 0.0332871 3.24494 0.0832178C3.3691 0.133148 3.48516 0.213592 3.59312 0.324549L2.84818 1.09015L3.25304 1.50624L3.02632 1.73925L3.57692 2.30513L4.30567 1.55617C4.28408 1.49515 4.26659 1.43135 4.2532 1.36477C4.2396 1.2982 4.23279 1.23162 4.23279 1.16505C4.23279 0.837725 4.34216 0.561664 4.56089 0.336866C4.77941 0.112289 5.04791 0 5.3664 0C5.44737 0 5.52435 0.00832179 5.59733 0.0249653C5.67009 0.0416089 5.74426 0.0665743 5.81984 0.0998614L5.01822 0.923717L5.60121 1.52288L6.40283 0.699029C6.44062 0.776699 6.46632 0.852927 6.47992 0.927712C6.49331 1.00272 6.5 1.08183 6.5 1.16505C6.5 1.49237 6.39074 1.76832 6.17223 1.9929C5.9535 2.2177 5.68489 2.3301 5.3664 2.3301C5.30162 2.3301 5.23684 2.32455 5.17206 2.31345C5.10729 2.30236 5.04521 2.28294 4.98583 2.2552L1.34211 6Z"
                    fill="#2B2F3E"
                  />
                </svg>
              </span>{" "}
              &nbsp;
              {props.t("Scope of Work")}
            </div>
            {projectInfo?.status === ProjectStatuses.DRAFT &&
              projectUser?.role?.name === Role.PROJECT_MANAGER && (
                <EditOutlinedIcon
                  style={{ fill: "#6B7083", fontSize: "14px" }}
                  onClick={() => setIsOpenScopeEdit(true)}
                />
              )}
          </div>
          {isOpenScopeEdit ? (
            <>
              <Input
                type="textarea"
                className="form-control"
                id="project-title-input"
                name="scope"
                rows={4}
                value={projectScope}
                onChange={(e) => setProjectScope(e.target.value)}
              />
              <div className="d-flex">
                <Button
                  className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30 mt-2"
                  variant="contained"
                  style={{ marginRight: "8px" }}
                  type="submit"
                  onClick={handleEdit}
                >
                  {props.t("Submit")}
                </Button>
                <Button
                  className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30 mt-2"
                  variant="contained"
                  type="submit"
                  onClick={() => setIsOpenScopeEdit(false)}
                >
                  {props.t("Cancel")}
                </Button>
              </div>
            </>
          ) : (
            <p className="projDetailDesc">
              {shouldTruncateScope ? (
                <>
                  {projectScope.slice(0, maxLength) + "..."}
                  <span
                    className="blue-pointer-text cursor-pointer"
                    onClick={toggleScopeExpansion}
                  >
                    read more
                  </span>
                </>
              ) : (
                <>
                  {projectScope ? projectScope : "N/A"}
                  {scopeLength > maxLength && isScopeExpanded && (
                    <span
                      className="blue-pointer-text cursor-pointer"
                      onClick={toggleScopeExpansion}
                    >
                      read less
                    </span>
                  )}
                </>
              )}
            </p>
          )}
        </div> */}
        <div className="proBlock scope mt-3 pb-3">
          <div className="d-flex gap-2">
            <h5 className="projDetailTitle">
              <span
                style={{ backgroundColor: "#C9F8FF", color: "#1195A9" }}
                className="dashboardProjectIcon"
              >
                <DescriptionIcon style={{ width: "14px", height: "14px" }} />
              </span>{" "}
              &nbsp;{props.t("Description")}
            </h5>
            {projectInfo?.status === ProjectStatuses.DRAFT &&
              projectUser?.role?.name === Role.PROJECT_MANAGER && (
                <EditOutlinedIcon
                  style={{ fill: "#6B7083", fontSize: "14px" }}
                  onClick={() => setIsOpenDescriptionEdit(true)}
                />
              )}
          </div>
          {isOpenDescriptionEdit ? (
            <>
              <Input
                type="textarea"
                className="form-control"
                id="project-title-input"
                rows={4}
                name="description"
                value={projectDescription}
                onChange={(e) => setProjectDescription(e.target.value)}
              />
              <div className="d-flex">
                <Button
                  className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30 mt-2"
                  style={{ marginRight: "8px" }}
                  type="submit"
                  variant="contained"
                  onClick={handleEdit}
                >
                  {props.t("Submit")}
                </Button>
                <Button
                  className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30 mt-2"
                  type="submit"
                  variant="contained"
                  onClick={() => setIsOpenDescriptionEdit(false)}
                >
                  {props.t("Cancel")}
                </Button>
              </div>
            </>
          ) : (
            <p className="projDetailDesc">
              {shouldTruncateDescription ? (
                <>
                  {projectDescription.slice(0, maxLength) + "..."}
                  <span
                    className="blue-pointer-text cursor-pointer"
                    onClick={toggleDescriptionExpansion}
                  >
                    read more
                  </span>
                </>
              ) : (
                <>
                  {projectDescription ? projectDescription : "N/A"}
                  {descriptionLength > maxLength && isDescriptionExpanded && (
                    <span
                      className="blue-pointer-text cursor-pointer"
                      onClick={toggleDescriptionExpansion}
                    >
                      read less
                    </span>
                  )}
                </>
              )}
            </p>
          )}
        </div>
        {/* <div className="proBlock scope m-3">
                    <h5 className="projDetailTitle">Scope Of Work</h5>
                    <p className="projDetailDesc">{projectScope ? projectScope : 'N/A'}</p>
                </div> */}
        {/* <div className='proBlock scope mt-3 pb-3'> */}
        {/* <h5 className="projDetailTitle">{props.t('Description')}</h5> */}
        {/* <p className='projDetailDesc'>{projectDescription ? projectDescription : 'N/A'}</p>
                </div> */}
        <div className="my-3 documentsTable">
          <div className="d-flex align-items-center justify-content-between">
            <h5>{props.t("Startup Files")}</h5>
            <div className="d-flex justify-content-end align-items-center mb-2">
              {projectTag === ProjectTag.ACTIVE &&
                hasCreatePermissionForProjectCoreDocument && (
                  <>
                    <Button
                      variant="contained"
                      className="popupButton edit_button w-100 main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30"
                      onClick={(e) => {
                        inputRef.current.click();
                      }}
                    >
                      <FileDownloadOutlinedIcon
                        style={{ transform: "rotate(180deg)" }}
                      />{" "}
                      &nbsp;
                      {props.t("Upload")}
                    </Button>
                    <input
                      onChange={handleFileUpload}
                      accept={AcceptFileType.toString()}
                      ref={inputRef}
                      type="file"
                      style={{ display: "none" }}
                      single
                    />
                  </>
                )}
            </div>
          </div>
          <React.Fragment>
            <div className="projectSubmission teamTable customTabCard">
              <Card
                className="viewProjectApproval"
                style={{ height: 500, width: "100%" }}
              >
                {selectedFiles?.length > 0 &&
                  selectedFiles.map((file, _key) => (
                    <>
                      <div className="d-flex flex-column justify-content-center align-items-center mx-5 my-4">
                        <span
                          className="me-3 fs-6 fw-semibold"
                          title={file.file.name}
                        >
                          {file.file.name}
                        </span>
                        <div className="progress w-75 my-auto">
                          <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={file.progress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: file.progress + "%" }}
                          ></div>
                        </div>
                        <span className="fs-6 fw-bolder">
                          {file.progress} %
                        </span>
                      </div>
                      <Divider
                        className="mb-2"
                        variant="fullWidth"
                        sx={{ borderBottomColor: "purple" }}
                      />
                    </>
                  ))}
                <ProjectInfoTab
                  disabled={projectTag !== ProjectTag.ACTIVE}
                  refresh={update}
                />
              </Card>
            </div>
          </React.Fragment>
        </div>
      </Card>
    </div>
  );
};

export default withTranslation()(ProjectInfo);
